<template>
  <div>
    <div class="x-banner">
      <!-- banner -->
      <BANNER></BANNER>
      <!-- 二级导航 -->
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>
    <div class="container-width location">
      当前位置:<router-link to="/">首页</router-link> >
      <router-link to="/yygk/home">医院概况</router-link> >
      {{ current.title }}
    </div>
    <div class="container-width">
      <!-- <h1>{{ topTitle }}</h1>
              <div v-html="topDescription"></div> -->
      <ARTICLE
        :current="current"
        :before="before"
        :after="after"
        :showBeforeAfter="showBeforeAfter"
        :showorigin="showorigin"
      ></ARTICLE>
    </div>
    <div class="container-width hospital_honor">
      <div class="honor_swiper">
        <ul class="swiper-wrapper">
          <li
            class="swiper-slide"
            v-for="(item, index) in yygkData"
            :key="index"
            v-if="index != 0"
            @click="goArticle(item)"
            style="width: 300px; height: 246px"
          >
            <div>
              <p class="time">{{ item.title }}</p>

              <div class="department">
                <p></p>
                <p>{{ item.introduction }}</p>
                <p><br /></p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="container-width swiper_control mt50">
      <ul class="clearFix">
        <li class="fl"><span></span></li>
        <li class="fr"><span></span></li>
      </ul>
    </div>
  </div>
</template>
<script>
import service from "../../service/yygk";
import BANNER from "../../components/banner/yygk";
export default {
  name: "YYGKARTICLE",
  data() {
    return {
      navigationData: [
        {
          name: "医院概况",
          path: "/yygk/home",
        },
      ],
      currentPath: "/yygk/home",
      current: {},
      // 上一篇
      before: {
        title: "",
        id: "",
        active: false,
      },
      // 下一篇
      after: {
        title: "",
        id: "",
        active: false,
      },
      showBeforeAfter: false, //是否显示上一篇 下一篇
      showorigin: false, //是否显示来源 发布时间 点击次数
      yygkData: [],
      pageIndex: 1,
      pageSize: 1000,
    };
  },
  components: {
    BANNER,
  },
  computed: {},
  created() {
    let id = this.$route.params.id;
    this.init(id);
  },
  beforeMount() {},
  methods: {
    init(id) {
      let parmes = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        isshow: 1,
      };
      service.getHosOverviewlist(parmes, (res) => {
        if (res.content.length) {
          res.content.map((item) => {
            if (item.introduction) {
              item.introduction =
                item.introduction.length > 40
                  ? item.introduction.substring(0, 40) + "..."
                  : item.introduction;
            }
          });
        }
        this.current = res.content[0];
        this.yygkData = res.content;
        this.$nextTick(() => {
          this.swiperiImg();
        });
      });
    },

    goArticle(e) {
      let articleId = e.id;
      const { href } = this.$router.resolve({
        path: `/yygk/article/${articleId}`,
      });
      window.open(href, "_blank");
    },

    swiperiImg() {
      var wW = $(window).width();
      var swipericon;
      if (wW > 768) {
        swipericon = new Swiper(".honor_swiper", {
          slidesPerView: "4",
          mode: "horizontal",
          loop: true,
          navigation: {            
            nextEl: ".fr",
            prevEl: ".fl",
          },
        });
      } else {
        swipericon = new Swiper(".honor_swiper", {
          slidesPerView: "2",
          mode: "horizontal",
        });
      }
    },
  },
  mounted() {},
  watch: {},
};
</script>
              
              
<style scoped lang="scss">
.swiper-slide {
  cursor: pointer;
}
</style>
              